export const state = () => ({
  time: null,
  message: null,
  color: null,
})
export const getters = {
  getTime(state) {
    return state.time
  },
}
export const mutations = {
  setInfo(state, message) {
    state.time = Date.now()
    state.message = message
    state.color = "secondary"
  },
  setSuccess(state, message) {
    state.time = Date.now()
    state.message = message
    state.color = "success"
  },
  setError(state, message){
    state.time = Date.now()
    state.message = message
    state.color = "red"
  }
}
